import { SingleSelectDropdown } from "Components/SingleSelectDropdown";
import { Flex, Typography } from "antd";
import { useQuery } from "@tanstack/react-query";
import { AddCollegeModal } from "./addNewCollege";
import { useState } from "react";
import debounce from "lodash.debounce";
import apiClient from "QueryClient/axiosClient";

const fetchColleges = async (search) => {
  const response = await apiClient.get(`/undergradColleges?q=${search}`);
  return response.data;
};

export const CollegeName = ({ selectedCollege, setCollege }) => {
  const { Title } = Typography;
  const [search, setSearch] = useState("");
  const { data, error, isLoading } = useQuery({
    queryKey: ["colleges", search],
    queryFn: () => fetchColleges(search),
  });
  const debounceSearch = debounce((value) => {
    setSearch(value);
  }, 500);
  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Title style={{ fontSize: "18px", fontWeight: "500" }}>
        College name
      </Title>
      <SingleSelectDropdown
        options={
          isLoading || error
            ? [{ label: "loading", value: "loading" }]
            : data?.data?.map((college) => ({
                label: college.name,
                value: college.name,
              }))
        }
        placeholder="Search College"
        loading={false}
        onChange={setCollege}
        value={selectedCollege}
        onSearch={debounceSearch}
      />
      <AddCollegeModal />
    </Flex>
  );
};
